document.addEventListener('DOMContentLoaded', () => {
  const contentWrapperElements = document.querySelectorAll('.content-wrapper')

  contentWrapperElements.forEach((contentWrapperElement) => {
    const ulElement = contentWrapperElement.querySelector('ul.row-cols-lg-3')

    if (ulElement) {
      const parentDiv = ulElement.parentNode
      contentWrapperElement.appendChild(ulElement)
      parentDiv.remove()

      ulElement.classList.remove('row-cols-lg-3')
    }
  })

  const formationsBlockElements =
    document.querySelectorAll('.formations-block')

  formationsBlockElements.forEach((formationsBlockElement) => {
    formationsBlockElement.classList.remove('row-cols-lg-4')
    formationsBlockElement.classList.add('row-cols-lg-3')
    formationsBlockElement.classList.add('row-cols-xl-4')
    formationsBlockElement.classList.remove('row-cols-xxl-4')
  })
})
